import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';

var HEADING_ELEMENTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var THEMES = ['cyprus', 'eden', 'eggplant', 'ocean', 'mulberry', 'deepTeal'];
var MAX_LEVEL = 4;
var MIN_LEVEL = 1;
var getThemeClassName = function (theme) {
    // Don't add class for invalid themes
    if (!THEMES.includes(theme))
        return '';
    return "nv-heading-color--".concat(theme);
};
var NvHeading = function (_a) {
    var _b = _a.element, Element = _b === void 0 ? 'h2' : _b, className = _a.className, theme = _a.theme, level = _a.level, children = _a.children, style = _a.style, 
    // Allows any data-* or aria-* attributes to be passed down to the component,
    // as well as any invalid TS identifier, like "random-attribute-x".
    dataAriaOrInvalidTSIdentifiers = __rest(_a, ["element", "className", "theme", "level", "children", "style"]);
    // Check if element is a valid heading tag
    if (!HEADING_ELEMENTS.includes(Element))
        return null;
    // Place level between range of 1 and 4 to match available classes
    var limitedLevel = Math.min(Math.max(level, MIN_LEVEL), MAX_LEVEL);
    var headingClassName = "nv-mh".concat(limitedLevel);
    var themeClassName = theme ? getThemeClassName(theme) : '';
    return (React.createElement(Element, __assign({}, dataAriaOrInvalidTSIdentifiers, { className: classNames(headingClassName, themeClassName, className), style: style }), children));
};

export { NvHeading as default };
//# sourceMappingURL=NvHeading.esm.js.map
